// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../public/static/img/rectangle-50.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../public/static/img/rectangle-5-1x-png.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.events-https-demo {
  background-color: #ffffff;
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
}

.events-https-demo .div {
  background-color: #ffffff;
  height: 1897px;
  position: relative;
  width: 1280px;
}

.events-https-demo .component {
  height: 145px;
  left: 570px;
  object-fit: cover;
  position: absolute;
  top: 1641px;
  width: 150px;
}

.events-https-demo .img {
  height: 19px;
  left: 1118px;
  object-fit: cover;
  position: absolute;
  top: 1822px;
  width: 89px;
}

.events-https-demo .element-the-mamahood {
  height: 16px;
  left: 454px;
  object-fit: cover;
  position: absolute;
  top: 1822px;
  width: 382px;
}

.events-https-demo .partner-with-us-the {
  height: 139px;
  left: 291px;
  object-fit: cover;
  position: absolute;
  top: 1662px;
  width: 140px;
}

.events-https-demo .overlap {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: 50% 50%;
  background-size: cover;
  height: 29px;
  left: 831px;
  position: absolute;
  top: 1714px;
  width: 168px;
}

.events-https-demo .FIRST-NAME {
  height: 16px;
  left: 15px;
  object-fit: cover;
  position: absolute;
  top: 7px;
  width: 71px;
}

.events-https-demo .overlap-group {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: 50% 50%;
  background-size: cover;
  height: 29px;
  left: 1011px;
  position: absolute;
  top: 1714px;
  width: 168px;
}

.events-https-demo .LAST-NAME {
  height: 16px;
  left: 17px;
  object-fit: cover;
  position: absolute;
  top: 7px;
  width: 68px;
}

.events-https-demo .EMAIL-wrapper {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: 50% 50%;
  background-size: cover;
  height: 29px;
  left: 831px;
  position: absolute;
  top: 1755px;
  width: 168px;
}

.events-https-demo .EMAIL {
  height: 16px;
  left: 15px;
  object-fit: cover;
  position: absolute;
  top: 7px;
  width: 36px;
}

.events-https-demo .sign-up-for-our {
  height: 26px;
  left: 831px;
  object-fit: cover;
  position: absolute;
  top: 1662px;
  width: 185px;
}

.events-https-demo .SEND-wrapper {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-position: 50% 50%;
  background-size: cover;
  height: 31px;
  left: 1012px;
  position: absolute;
  top: 1755px;
  width: 62px;
}

.events-https-demo .SEND {
  height: 28px;
  left: 13px;
  object-fit: cover;
  position: absolute;
  top: 0;
  width: 39px;
}

.events-https-demo .about-join-community {
  height: 139px;
  left: 110px;
  object-fit: cover;
  position: absolute;
  top: 1662px;
  width: 141px;
}

.events-https-demo .mamahood-events {
  height: 69px;
  left: 292px;
  object-fit: cover;
  position: absolute;
  top: 164px;
  width: 696px;
}

.events-https-demo .overlap-group-2 {
  height: 1078px;
  left: 32px;
  position: absolute;
  top: 304px;
  width: 1230px;
}

.events-https-demo .FILTERS {
  height: 32px;
  left: 0;
  object-fit: cover;
  position: absolute;
  top: 155px;
  width: 90px;
}

.events-https-demo .screenshot {
  height: 541px;
  left: 19px;
  object-fit: cover;
  position: absolute;
  top: 0;
  width: 1179px;
}

.events-https-demo .screenshot-2 {
  height: 575px;
  left: 12px;
  object-fit: cover;
  position: absolute;
  top: 503px;
  width: 1218px;
}

.events-https-demo .group {
  height: 69px;
  left: 31px;
  object-fit: cover;
  position: absolute;
  top: 24px;
  width: 1206px;
}

.events-https-demo .screenshot-3 {
  height: 180px;
  left: 51px;
  object-fit: cover;
  position: absolute;
  top: 1398px;
  width: 1198px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Events/style.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yDAAkE;EAClE,4BAA4B;EAC5B,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,yDAAkE;EAClE,4BAA4B;EAC5B,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,yDAAkE;EAClE,4BAA4B;EAC5B,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yDAAwE;EACxE,4BAA4B;EAC5B,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,cAAc;EACd,UAAU;EACV,kBAAkB;EAClB,UAAU;EACV,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,OAAO;EACP,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,aAAa;EACb,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,MAAM;EACN,aAAa;AACf;;AAEA;EACE,aAAa;EACb,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,aAAa;EACb,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,aAAa;AACf","sourcesContent":[".events-https-demo {\n  background-color: #ffffff;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  width: 100%;\n}\n\n.events-https-demo .div {\n  background-color: #ffffff;\n  height: 1897px;\n  position: relative;\n  width: 1280px;\n}\n\n.events-https-demo .component {\n  height: 145px;\n  left: 570px;\n  object-fit: cover;\n  position: absolute;\n  top: 1641px;\n  width: 150px;\n}\n\n.events-https-demo .img {\n  height: 19px;\n  left: 1118px;\n  object-fit: cover;\n  position: absolute;\n  top: 1822px;\n  width: 89px;\n}\n\n.events-https-demo .element-the-mamahood {\n  height: 16px;\n  left: 454px;\n  object-fit: cover;\n  position: absolute;\n  top: 1822px;\n  width: 382px;\n}\n\n.events-https-demo .partner-with-us-the {\n  height: 139px;\n  left: 291px;\n  object-fit: cover;\n  position: absolute;\n  top: 1662px;\n  width: 140px;\n}\n\n.events-https-demo .overlap {\n  background-image: url(../../../public/static/img/rectangle-50.png);\n  background-position: 50% 50%;\n  background-size: cover;\n  height: 29px;\n  left: 831px;\n  position: absolute;\n  top: 1714px;\n  width: 168px;\n}\n\n.events-https-demo .FIRST-NAME {\n  height: 16px;\n  left: 15px;\n  object-fit: cover;\n  position: absolute;\n  top: 7px;\n  width: 71px;\n}\n\n.events-https-demo .overlap-group {\n  background-image: url(../../../public/static/img/rectangle-50.png);\n  background-position: 50% 50%;\n  background-size: cover;\n  height: 29px;\n  left: 1011px;\n  position: absolute;\n  top: 1714px;\n  width: 168px;\n}\n\n.events-https-demo .LAST-NAME {\n  height: 16px;\n  left: 17px;\n  object-fit: cover;\n  position: absolute;\n  top: 7px;\n  width: 68px;\n}\n\n.events-https-demo .EMAIL-wrapper {\n  background-image: url(../../../public/static/img/rectangle-50.png);\n  background-position: 50% 50%;\n  background-size: cover;\n  height: 29px;\n  left: 831px;\n  position: absolute;\n  top: 1755px;\n  width: 168px;\n}\n\n.events-https-demo .EMAIL {\n  height: 16px;\n  left: 15px;\n  object-fit: cover;\n  position: absolute;\n  top: 7px;\n  width: 36px;\n}\n\n.events-https-demo .sign-up-for-our {\n  height: 26px;\n  left: 831px;\n  object-fit: cover;\n  position: absolute;\n  top: 1662px;\n  width: 185px;\n}\n\n.events-https-demo .SEND-wrapper {\n  background-image: url(../../../public/static/img/rectangle-5-1x-png.png);\n  background-position: 50% 50%;\n  background-size: cover;\n  height: 31px;\n  left: 1012px;\n  position: absolute;\n  top: 1755px;\n  width: 62px;\n}\n\n.events-https-demo .SEND {\n  height: 28px;\n  left: 13px;\n  object-fit: cover;\n  position: absolute;\n  top: 0;\n  width: 39px;\n}\n\n.events-https-demo .about-join-community {\n  height: 139px;\n  left: 110px;\n  object-fit: cover;\n  position: absolute;\n  top: 1662px;\n  width: 141px;\n}\n\n.events-https-demo .mamahood-events {\n  height: 69px;\n  left: 292px;\n  object-fit: cover;\n  position: absolute;\n  top: 164px;\n  width: 696px;\n}\n\n.events-https-demo .overlap-group-2 {\n  height: 1078px;\n  left: 32px;\n  position: absolute;\n  top: 304px;\n  width: 1230px;\n}\n\n.events-https-demo .FILTERS {\n  height: 32px;\n  left: 0;\n  object-fit: cover;\n  position: absolute;\n  top: 155px;\n  width: 90px;\n}\n\n.events-https-demo .screenshot {\n  height: 541px;\n  left: 19px;\n  object-fit: cover;\n  position: absolute;\n  top: 0;\n  width: 1179px;\n}\n\n.events-https-demo .screenshot-2 {\n  height: 575px;\n  left: 12px;\n  object-fit: cover;\n  position: absolute;\n  top: 503px;\n  width: 1218px;\n}\n\n.events-https-demo .group {\n  height: 69px;\n  left: 31px;\n  object-fit: cover;\n  position: absolute;\n  top: 24px;\n  width: 1206px;\n}\n\n.events-https-demo .screenshot-3 {\n  height: 180px;\n  left: 51px;\n  object-fit: cover;\n  position: absolute;\n  top: 1398px;\n  width: 1198px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
